/**
 * Google Ads conversion IDs and labels — single source of truth.
 *
 * These used to be inlined as string literals at four separate call sites
 * (DemoForm, WebinarNewsletterForm, the webinar registration form, MeetClient),
 * which meant a re-issued label in the Ads UI had to be found and replaced by
 * grep. The Google tag for this account is `AW-16957461978` / `GT-573WG44X`;
 * only the `AW-` form is used for `send_to`.
 */

export const GOOGLE_ADS_CONVERSION_ID = "AW-16957461978";

export const GOOGLE_ADS_CONVERSION_LABELS = {
  /** Lead forms: demo request, webinar registration, newsletter signup. */
  lead: "kNG1CPST-JkbENqr-ZU_",
  /** Meeting booked via Calendly (click-out and confirmed booking). */
  meeting: "vuHVCKmVj7AcENqr-ZU_",
} as const;

export type GoogleAdsConversionLabel =
  (typeof GOOGLE_ADS_CONVERSION_LABELS)[keyof typeof GOOGLE_ADS_CONVERSION_LABELS];
